<template>
  <a-main-button
    :to="leadFormTo"
    :font-small="fontSmall"
    :border-radius-small="borderRadiusSmall"
    class="nominate-button__wrapper"
    v-on="$listeners"
  >
    <slot />
  </a-main-button>
</template>

<script>
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import AMainButton from 'shared/AMainButton/index.vue'
import { ELEMENT_ID, ELEMENT_SELECTOR_BY_ELEMENT_ID } from 'enums/element-id'
import { ROUTE } from 'enums/routes'

export default {
  name: 'ANominateButton',
  components: { AMainButton },
  props: {
    fontSmall: propValidator([PROP_TYPES.BOOLEAN], false, false),
    borderRadiusSmall: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  computed: {
    leadFormTo() {
      return {
        path: ROUTE.HOMEPAGE,
        query: this.$route.query,
        hash: ELEMENT_SELECTOR_BY_ELEMENT_ID[ELEMENT_ID.HP_LEAD_FORM]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.nominate-button__wrapper {
  text-decoration: none;
}
</style>
